// @flow
import React from 'react';
import { Link } from 'react-router-dom';

import { withHelmet } from 'infrastructure/seo/Helmet';

import imageNotFound from 'assets/img/404/not-found.svg';

type Props = {
  noMargin?: boolean,
};

const PageNotFound = ({ noMargin }: Props) => (
  <>
    <section className={`banner ${noMargin ? '' : 'banner--404'} banner--big banner--center`}>
      <div className="banner__thumbnail img-blue-100" />
    </section>
    <div className="container">
      <div className="row">
        <div className="col col--center col-md-6 col-lg-6">
          <div className="box not-found">
            <img src={imageNotFound} alt="La page que vous recherchez semble introuvable" />
            <h1 className="ft-h1">Oops...!</h1>
            <p className="ft-secondary">La page que vous recherchez semble introuvable</p>
            <Link to="/" className="btn btn--cheer">
              <i className="icon icon-chevron-right link-icon is-inline" />
              <span>Retour à la page d&apos;accueil</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </>
);

PageNotFound.defaultProps = {
  noMargin: false,
};

export default withHelmet(PageNotFound)((Helmet) => (
  <Helmet>
    <meta name="prerender-status-code" content="404" />
  </Helmet>
)) ;
